import React from "react";
import "./CeramicComponents.css";

// ✅ IMPORT IMAGES FROM ASSETS
import sponge1 from "../assets/sponge1.jpg";
import sponge2 from "../assets/sponge2.jpg";
import sponge3 from "../assets/sponge3.jpg";
import bricks from "../assets/bricks.jpg";
import pipe1 from "../assets/pipe1.png";
import pipe2 from "../assets/pipe2.png";
import pipe3 from "../assets/pipe3.png";
import bg2 from "../assets/bg2.png";

export default function CeramicComponents() {
  return (
    <>
      {/* ✅ FIXED HEADER BACKGROUND */}
      <header
        className="ceramic-header"
        style={{
          background: `linear-gradient(rgba(0,0,0,0.5),
                       rgba(0,0,0,0.5)), url(${bg2}) center/cover no-repeat`,
        }}
      >
        <h1>
          Engineered Ceramic Components:
          Silicon Carbide and Alumina
          Innovations for Everyday Industry</h1> 
        
      </header>

      <div className="container">

        <div className="content-section">
          <h2>Premium Abrasive Sponge Blocks</h2>
          <p>
            <span className="highlight">Precision-Finished by Innovation</span> |{" "}
            <span className="highlight">
              Built for Durability & Versatility
            </span>
          </p>

          <p>
            Introducing our high-performance abrasive sponge blocks — expertly
            engineered using <strong>Aluminum Oxide (Al₂O₃)</strong> and{" "}
            <strong>Silicon Carbide (SiC)</strong> abrasives. Available in a
            full range of grits from #8 to #2000.
          </p>

          {/* ✅ FIXED IMAGE */}
          <img src={sponge2} alt="Compressed Sponge Block" />

          <h2>🔹 Abrasive Options:</h2>
          <ul>
            <li>Al₂O₃ (Aluminum Oxide): Pink, Blue, Black, Brown, White</li>
            <li>SiC (Silicon Carbide): Black and Green</li>
          </ul>

          <img src={sponge1} alt="Two Grit Abrasive Blocks" />

          <h2>🔹 Key Features:</h2>
          <ul>
            <li>Flexible sponge core for contouring and consistent contact</li>
            <li>High cutting power with excellent durability</li>
            <li>Suitable for wet and dry applications</li>
            <li>Ideal for metal, wood, composites, ceramics, and glass</li>
          </ul>

          <h2>🔹 Applications:</h2>
          <ul>
            <li>Automotive refinishing</li>
            <li>Surface preparation</li>
            <li>Wood and metal finishing</li>
            <li>Polishing and deburring</li>
            <li>Glass and ceramic smoothing</li>
          </ul>

          <img src={sponge3} alt="Close-up of Abrasive Surface" />

          <h2>🔹 Customization Available:</h2>
          <p>
            We offer tailored grit sizes, dimensions, and abrasive materials to
            meet your specific application needs.
          </p>
          <p>
            📦 <strong>Bulk and OEM Orders Welcome</strong>
            <br />
            Contact us to discuss custom solutions, samples, and pricing.
          </p>
        </div>

        {/* Abrasive Bricks Section */}
        <div className="content-section">
          <h2>
            Customizable Silicon Carbide and Aluminum Oxide Abrasive Bricks
          </h2>

          <p>
            Elevate your sharpening, honing, and finishing processes with our
            customizable <strong>Silicon Carbide (SiC)</strong> and{" "}
            <strong>Aluminum Oxide (Al₂O₃)</strong> abrasive bricks.
          </p>

          <img src={bricks} alt="Stacked Abrasive Bricks" />

          <h3>Key Features & Benefits:</h3>
          <ul>
            <li>Customizable Dimensions & Volume</li>
            <li>Comprehensive Grit Selection</li>
            <li>Premium Abrasive Materials</li>
            <li>Versatile Applications</li>
          </ul>

          <h3>Applications:</h3>
          <ul>
            <li>Tool Sharpening & Maintenance</li>
            <li>Industrial Finishing</li>
            <li>Mold & Die Care</li>
            <li>Material Polishing</li>
            <li>General Abrasion</li>
          </ul>
        </div>

        {/* Cylindrical Components */}
        <div className="content-section">
          <h2>
            Aluminum Oxide & Silicon Carbide Cylindrical Components
          </h2>

          <p>
            Optimize your grinding, honing, and specialized industrial
            processes with our high-performance cylindrical forms.
          </p>

          <div className="images">
            <img src={pipe2} alt="Cylinder 1" />
            <img src={pipe1} alt="Cylinder 2" />
            <img src={pipe3} alt="Cylinder 3" />
          </div>

          <ul>
            <li>Customizable Dimensions</li>
            <li>Multiple Aluminum Oxide Grades</li>
            <li>High-performance Silicon Carbide Options</li>
            <li>Consistent density, porosity, and accuracy</li>
          </ul>
        </div>

      </div>
    </>
  );
}
